var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
export class ChristieGsSeries {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`(FRZ ?)`, /\(FRZ!(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`(FRZ ${freeze ? '1' : '0'})`, /\(FRZ!(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    // Get freeze
                    let match = yield this.socket.send(`(FRZ ?)`, /\(FRZ!(\d+)/i, [
                        'get.displayFreeze',
                    ]);
                    const freeze = parseInt(match[1]);
                    // Set the freeze to current value to see if freeze is supported since we may be
                    // able to get the freeze but not set it.
                    match = yield this.socket.send(`(FRZ ${freeze})`, /\(FRZ!(\d+)/i, [
                        'set.displayFreeze',
                    ]);
                    if (match[1] !== undefined) {
                        return true;
                    }
                    return false;
                }
                catch (error) {
                    if (error instanceof TransportError && error.code === 'sendTimeout')
                        return false;
                    throw error;
                }
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`(PWR ?)`, /\(PWR!(\d+)/i, tags);
                return parseInt(match[1], 10) === 1;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                let retValue = power;
                // Power set commands do not seem to send a response
                this.state.busy.update(true);
                try {
                    const match = yield this.socket.send(`(PWR ${power ? '1' : '0'})`, /\(PWR!(\d+)/i, tags);
                    if (match[1])
                        retValue = parseInt(match[1], 10) === 1;
                }
                catch (error) {
                    if (!(error instanceof TransportError && error.code === 'sendTimeout')) {
                        this.state.busy.update(false);
                        throw error;
                    }
                }
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 15000 : 2000);
                this.framework.suspend(power ? 15000 : 2000);
                return retValue;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`(SIN+MAIN ?)`, /\(SIN\+MAIN!(\d+)/i, tags);
                return parseInt(match[1], 10).toString();
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`(SIN+MAIN ${code})`, /\(SIN\+MAIN!(\d+)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return parseInt(match[1], 10).toString();
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 4000, controls: ['power', 'videoInput'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: '(PWR ?)',
                    next: /\(PWR!(\d+)/i,
                },
            ], credentials);
        });
    }
}
// static properties
ChristieGsSeries.driverType = 'socketDriver';
ChristieGsSeries.key = '-NAjvTprma_emWzHRKIJ';
ChristieGsSeries.baseSocketOptions = {
    commandExtractor: {
        terminators: [''],
        unterminatedRegExp: /\([^!]+!\d+\)/,
    },
    sendTerminator: '',
};
ChristieGsSeries.socketOptions = [
    Object.assign(Object.assign({}, ChristieGsSeries.baseSocketOptions), { port: 3002 }),
    Object.assign(Object.assign({}, ChristieGsSeries.baseSocketOptions), { port: 4999 }),
];
